import inViewport from '@resources/js/helpers/inViewport'

// визначаємо порібну мінімальну ширину блоку з логотипами
const REQUIRED_LOGOS_INNER_WIDTH = window.innerWidth * 2

const logosContainerElement = document.querySelector('.js-logos-container')
const logosBlockElement = document.querySelector('.js-logos-block')

const duplicateLogosBlockIfNeed = () => {
    while (logosContainerElement.offsetWidth < REQUIRED_LOGOS_INNER_WIDTH) {
        logosContainerElement.appendChild(logosBlockElement.cloneNode(true))
    }
}

inViewport(logosContainerElement, duplicateLogosBlockIfNeed)
